<template>
  <div class="countdown">
    <div class="countdown__box">
      <div>{{ objectDate.days }}</div>
      <small>Días</small>
    </div>
    <div class="countdown__box">
      <div>{{ objectDate.hours }}</div>
      <small>Horas</small>
    </div>
    <div class="countdown__box">
      <div>{{ objectDate.minutes }}</div>
      <small>Min</small>
    </div>
    <div class="countdown__box">
      <div>{{ objectDate.seconds }}</div>
      <small>Seg</small>
    </div>
  </div>
</template>

<script>
function padZero(n) {
  return n > 9 ? `${n}` : `0${n}`;
}

function getTimeRemaingObject(distance) {
  let days = "00";
  let hours = "00";
  let minutes = "00";
  let seconds = "00";

  if (distance > 0) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    days = padZero(Math.floor(distance / day));
    hours = padZero(Math.floor((distance % day) / hour));
    minutes = padZero(Math.floor((distance % hour) / minute));
    seconds = padZero(Math.floor((distance % minute) / second));
  }

  return { days, hours, minutes, seconds };
}

export default {
  props: {
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      distance: 0
    };
  },
  mounted() {
    this.interval();
  },
  computed: {
    objectDate() {
      return getTimeRemaingObject(this.distance);
    }
  },
  methods: {
    interval() {
      const tId = setInterval(() => {
        const dateEndTime = new Date(this.date).getTime();
        const nowTime = new Date().getTime();
        this.distance = dateEndTime - nowTime;
        if (this.distance < 1000) {
          clearInterval(tId);
        }
      }, 1000);
    }
  }
};
</script>
